import Blue from '~/core'
import { defaults } from 'lodash-es'
import { asyncScroll } from '../utils'

new Blue({
  name: 'Back To Top',
  selector: 'body',
  setup(body) {
    const header = body.querySelector('header.header')
    const modals = body.querySelector('.site-modals')
    const config = Object.fromEntries(
      Object.entries(body.dataset).reduce((_config, [k, v]) => {
        if (!k.startsWith('backToTop')) return _config

        k = k.replace('backToTop', '').toLowerCase()

        if (v.length == 0) v = ''
        else if (!isNaN(v)) v = Number(v)
        else if (v.toLowerCase() === 'true') v = true
        else if (v.toLowerCase() === 'false') v = false

        _config.push([k, v])
        return _config
      }, []),
    )
    const { text, active } = defaults(config, {
      text: '',
      active: true,
    })

    if (!active) return

    const button = this.$createElement({
      tag: 'button',
      attributes: { class: 'back-to-top btn' },
      text,
    })

    const setActiveState = () => {
      const scrollHeight = body.scrollHeight
      const pageHeight = body.offsetHeight
      const trigger = pageHeight * 0.8
      const pos = window.scrollY

      if (scrollHeight <= pageHeight) return

      button.classList[pos > trigger ? 'add' : 'remove']('is-active')
    }

    const scrollToTop = async () => {
      await asyncScroll({ method: 'scrollTo', top: 0 })
      header.querySelector('a, button, [tab-index="0"]').focus()
    }

    button.addEventListener('click', scrollToTop)
    window.addEventListener('scroll', setActiveState)
    if (modals != null) {
      modals.insertAdjacentElement('afterbegin', button)
    }
    setActiveState()
  },
})
